/**
 * Bus globale per mostrare l'ultimo messaggio (success/error/info/warning/loading)
 * accanto al nome dell'app, in modo persistente. Sostituisce comportamento toast
 * "scompaiono dopo 3 secondi" con "rimangono finché non arriva il prossimo".
 *
 * I toast normali continuano a funzionare in parallelo: questo bus è popolato
 * automaticamente dal monkey-patch di sonner in index.js.
 */

const KEY = '__clabLastMessage';
const EVT = 'clab:message';
const STORAGE_KEY = 'clab_last_message';

/** Pubblica un nuovo messaggio sul bus. */
export function publishMessage(type, message, description = '') {
  const msg = {
    type: type || 'info',
    message: typeof message === 'string' ? message : String(message ?? ''),
    description: description || '',
    timestamp: new Date().toISOString(),
  };
  try { window[KEY] = msg; } catch (_) {}
  // Persisti tra reload soft (utile dopo refresh post-azione)
  try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(msg)); } catch (_) {}
  try { window.dispatchEvent(new CustomEvent(EVT, { detail: msg })); } catch (_) {}
}

/** Restituisce l'ultimo messaggio noto (o null). */
export function getLastMessage() {
  try {
    if (window[KEY]) return window[KEY];
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (_) {
    return null;
  }
}

/** Iscrive un callback al bus. Ritorna funzione di unsubscribe. */
export function subscribeMessage(cb) {
  const handler = (e) => cb(e.detail);
  window.addEventListener(EVT, handler);
  return () => window.removeEventListener(EVT, handler);
}

/** Pulisce manualmente il messaggio. */
export function clearMessage() {
  try { window[KEY] = null; } catch (_) {}
  try { sessionStorage.removeItem(STORAGE_KEY); } catch (_) {}
  try { window.dispatchEvent(new CustomEvent(EVT, { detail: null })); } catch (_) {}
}
